import posthog from "posthog-js";

const KEY = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
const HOST =
  (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ?? "https://us.i.posthog.com";

let initialized = false;

if (KEY) {
  posthog.init(KEY, {
    api_host: HOST,
    capture_pageview: true,
    capture_pageleave: true,
  });
  posthog.capture("app_loaded");
  initialized = true;
}

export const isAnalyticsEnabled = () => initialized;

export function identifyFromAccessToken(token: string | null | undefined) {
  if (!initialized || !token) return;
  try {
    const payload = token.split(".")[1];
    if (!payload) return;
    const json = atob(payload.replace(/-/g, "+").replace(/_/g, "/"));
    const claims = JSON.parse(json) as { sub?: string; email?: string };
    if (!claims.sub) return;
    posthog.identify(claims.sub, { email: claims.email });
  } catch {
    // never break auth on analytics failure
  }
}

export function resetAnalytics() {
  if (initialized) posthog.reset();
}

export default posthog;
